const getMatchingVariants = (
  options: string[],
  variants: any[],
) : any[] => {
  return variants.filter((variant) =>
    variant.options.every(
      (variantOption, i) =>
        !options[i] || variantOption === options[i]
    )
  );
};

export default getMatchingVariants;
